import React from 'react';
import PropTypes from 'prop-types';

const HeaderTopNav = ({ children }) => <nav className="c-header-top__nav">
    <ul className="o-list-inline  c-header-top__list">{children}</ul>
  </nav>

export default HeaderTopNav;

HeaderTopNav.propTypes = {
  children: PropTypes.node.isRequired,
};
